import React from 'react';
import Select from '../Select/Select';

export const COLORS = [
  { value: '#FFFFFF', label: 'Белый' },
  { value: '#000000', label: 'Чёрный' },
  { value: '#808080', label: 'Серый' },
  { value: '#FF0000', label: 'Красный' },
  { value: '#FFA500', label: 'Оранжевый' },
  { value: '#FFFF00', label: 'Жёлтый' },
  { value: '#00FF00', label: 'Зелёный' },
  { value: '#00bfff', label: 'Голубой' },
  { value: '#0000ff', label: 'Синий' },
  { value: '#800080', label: 'Фиолетовый' },
  { value: '#964b00', label: 'Коричневый' },
  { value: '#FFEFDF', label: 'Бежевый' },
  // Оттенки из прайсов производителей — для клиента это отдельные цвета
  { value: '#0B1F3A', label: 'Тёмно-синий' },
  { value: '#4A90D9', label: 'Небесно-синий' },
  { value: '#A7D3F0', label: 'Светло-голубой' },
  { value: '#C0C0C0', label: 'Светло-серый' },
  { value: '#4F4F4F', label: 'Тёмно-серый' },
  { value: '#F7F9FA', label: 'Снежно-белый' },
  { value: '#F2EFE6', label: 'Белый жемчужный' },
  { value: '#D6D6D6', label: 'Серебристый' },
  { value: '#D4AF37', label: 'Золотистый' },
  { value: '#C2B280', label: 'Песочный' },
  // Цвета, которыми машины реально приходят в сток от заводов: без них фотографию
  // не к чему привязать, и на витрину уходит общее фото модели не того цвета
  { value: '#EDEDE8', label: 'Бело-дымчатый' },
  { value: '#F2F2EF', label: 'Белый перламутр' },
  { value: '#15171C', label: 'Чёрный перламутр' },
  { value: '#9BA1A6', label: 'Пепельно-серый' },
  { value: '#7E8C7A', label: 'Серо-зелёный' },
  { value: '#6E8CA0', label: 'Серо-голубой' },
  { value: '#8FBF4F', label: 'Светло-зелёный' },
  { value: '#2E4A2E', label: 'Тёмно-зелёный' },
  { value: '#40E0D0', label: 'Бирюзовый' },
  { value: '#41474D', label: 'Графитовый' },
  { value: '#71797E', label: 'Стальной' },
  { value: '#1B1B1B', label: 'Чёрно-матовый' },
  { value: '#7B1E24', label: 'Бордовый' },
];

const SelectColor = ({ label, ...props }) => {
  return <Select options={COLORS} label={label || 'Цвет'} placeholder={'Выберите из списка'} {...props} />;
};

export default SelectColor;
